// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6f9fcc6a","455":"8bd6e855","970":"687fb486","977":"1c556c67"}[chunkId] + ".chunk.js";
};